import { observer } from 'mobx-react';
import * as React from 'react';
import NavUserImpl from './NavUserImpl';

interface Props {}

const NavUser: React.FC<Props> = () => <NavUserImpl />;

export default observer(NavUser);
